/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationRequestOrderPostRequest
 */
export interface JpCoBenefitoneBsdpBffPresentationRequestOrderPostRequest {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestOrderPostRequest
     */
    customerNo?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestOrderPostRequest
     */
    menuNo?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestOrderPostRequest
     */
    planId?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestOrderPostRequest
     */
    orderSite?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestOrderPostRequest
     */
    boCode?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestOrderPostRequest
     */
    appliOrderFlag?: string;
}

export function JpCoBenefitoneBsdpBffPresentationRequestOrderPostRequestFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationRequestOrderPostRequest {
    return JpCoBenefitoneBsdpBffPresentationRequestOrderPostRequestFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationRequestOrderPostRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationRequestOrderPostRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'customerNo': !exists(json, 'customerNo') ? undefined : json['customerNo'],
        'menuNo': !exists(json, 'menuNo') ? undefined : json['menuNo'],
        'planId': !exists(json, 'planId') ? undefined : json['planId'],
        'orderSite': !exists(json, 'orderSite') ? undefined : json['orderSite'],
        'boCode': !exists(json, 'boCode') ? undefined : json['boCode'],
        'appliOrderFlag': !exists(json, 'appliOrderFlag') ? undefined : json['appliOrderFlag'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationRequestOrderPostRequestToJSON(value?: JpCoBenefitoneBsdpBffPresentationRequestOrderPostRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'customerNo': value.customerNo,
        'menuNo': value.menuNo,
        'planId': value.planId,
        'orderSite': value.orderSite,
        'boCode': value.boCode,
        'appliOrderFlag': value.appliOrderFlag,
    };
}

